<template>
  <span v-if="props.kpi !== null" class="flex items-center" :class="kpiClass">
    <IconArrowUp v-if="isPositiveKPI" :size="props.size" />
    <IconArrowDown v-if="isNegativeKPI" :size="props.size" />
    {{ kpi }}%</span
  >
</template>

<script setup lang="ts">
import { computed } from 'vue'

import type { IconProps } from '@ds/components/Icon'
import { IconArrowDown } from '@ds/icons/IconArrowDown'
import { IconArrowUp } from '@ds/icons/IconArrowUp'

const props = defineProps<{
  kpi: number | null
  size?: IconProps['size']
}>()

const isPositiveKPI = computed(() => {
  return props.kpi !== null && props.kpi > 0
})

const isNegativeKPI = computed(() => {
  return props.kpi !== null && props.kpi < 0
})

const kpiClass = computed(() => {
  if (isPositiveKPI.value) return 'text-static-success-hi'
  if (isNegativeKPI.value) return 'text-static-danger-hi'

  return 'text-static-default-low'
})
</script>
